import { Card } from '@paysense-india-services/elevate-web'

const CardComponent = ({
  children,
  className,
  footer,
  footerClassName,
  header,
  headerClassName
}) => {
  return (
    <Card
      className={`ew-bg-primary ew-rounded-lg ew-border ew-w-100 ew-shadow-none ${className} ${
        footer ? 'ew-px-16 ew-pt-16 ew-pb-0' : 'ew-p-16'
      }`}>
      {header ? (
        <Card.Header className={`ew-py-0 ${headerClassName || ''}`}>{header}</Card.Header>
      ) : null}
      {children}
      {footer ? (
        <Card.Footer className={`ew-mt-16 ew-p-0 ${footerClassName || ''}`}>{footer}</Card.Footer>
      ) : null}
    </Card>
  )
}

export default CardComponent
